module.exports = __webpack_public_path__ + "static/media/covifacturalogo.ec996c53.svg";